const cards = [
  {
    title: '某顶流男星婚内出轨实锤？深夜视频画面全网疯传',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20red%20and%20black%20composition%20with%20geometric%20shapes%20representing%20celebrity%20scandal%20and%20breaking%20news%2C%20dark%20atmospheric%20background%20with%20warm%20red%20accents%2C%20editorial%20design%20aesthetic%2C%20bold%20visual%20impact%20with%20dramatic%20lighting%20and%20tension&width=800&height=500&seq=card-01-2026&orientation=landscape',
    tag: '娱乐圈',
    time: '3小时前',
    reads: 128000,
    comments: 3560,
  },
  {
    title: '知名餐饮品牌后厨卫生状况堪忧，内部员工晒实拍图',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20composition%20with%20layered%20geometric%20shapes%20in%20amber%20and%20dark%20red%2C%20representing%20food%20safety%20exposure%20theme%2C%20modern%20editorial%20design%20with%20dramatic%20contrast%2C%20clean%20minimalist%20lines%20and%20bold%20texture%20overlay&width=800&height=500&seq=card-02-2026&orientation=landscape',
    tag: '社会',
    time: '5小时前',
    reads: 96000,
    comments: 2180,
  },
  {
    title: '某短视频平台大V人设崩塌，背后产业链遭深度起底',
    image: 'https://readdy.ai/api/search-image?query=Bold%20abstract%20visual%20with%20warm%20crimson%20and%20dark%20amber%20gradients%2C%20geometric%20fragments%20representing%20social%20media%20exposure%2C%20dramatic%20shadow%20play%20and%20layered%20composition%2C%20modern%20editorial%20style%20with%20high%20contrast%20and%20visual%20tension&width=800&height=500&seq=card-03-2026&orientation=landscape',
    tag: '网红',
    time: '7小时前',
    reads: 215000,
    comments: 8720,
  },
  {
    title: '某上市公司财务报表疑点重重，证监会已介入调查',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20scandal%20visual%20with%20dark%20red%20and%20gold%20geometric%20patterns%2C%20layered%20rectangular%20shapes%20representing%20financial%20documents%2C%20dramatic%20lighting%20on%20abstract%20forms%2C%20modern%20editorial%20composition%20with%20warm%20atmospheric%20tones&width=800&height=500&seq=card-04-2026&orientation=landscape',
    tag: '财经',
    time: '9小时前',
    reads: 187000,
    comments: 5340,
  },
  {
    title: '当红女团成员被指霸凌队友，聊天记录截图流出引热议',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20visual%20with%20warm%20red%20and%20deep%20burgundy%20layered%20shapes%2C%20representing%20entertainment%20industry%20conflict%2C%20bold%20geometric%20composition%20with%20atmospheric%20lighting%2C%20modern%20editorial%20design%20aesthetic%20with%20strong%20emotional%20impact&width=800&height=500&seq=card-05-2026&orientation=landscape',
    tag: '娱乐圈',
    time: '11小时前',
    reads: 312000,
    comments: 12800,
  },
  {
    title: '某电商平台双11数据造假，商家联名举报函全文曝光',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20data%20scandal%20visual%20with%20warm%20amber%20and%20crimson%20gradients%2C%20geometric%20grid%20patterns%20representing%20digital%20data%2C%20layered%20composition%20with%20dramatic%20shadows%2C%20modern%20editorial%20design%20with%20bold%20contrast%20and%20clean%20lines&width=800&height=500&seq=card-06-2026&orientation=landscape',
    tag: '电商',
    time: '15小时前',
    reads: 145000,
    comments: 4210,
  },
  {
    title: '某热门综艺导演组内讧升级，核心团队集体出走',
    image: 'https://readdy.ai/api/search-image?query=Bold%20abstract%20composition%20with%20warm%20red%20and%20dark%20orange%20geometric%20shapes%2C%20representing%20entertainment%20industry%20drama%2C%20layered%20visual%20elements%20with%20dramatic%20contrast%2C%20modern%20editorial%20style%20with%20atmospheric%20depth%20and%20texture&width=800&height=500&seq=card-07-2026&orientation=landscape',
    tag: '综艺',
    time: '18小时前',
    reads: 108000,
    comments: 2940,
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-primary-600 font-medium bg-primary-50 px-3 py-1 rounded-full">吃瓜盘点</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门吃瓜</h2>
          <p className="mt-2 text-sm text-foreground-500">精选最热爆料，让你一次吃够瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.map((card, index) => (
            <article key={index} className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-colors cursor-pointer group">
              <div className="relative aspect-[16/10] bg-background-200 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 text-xs px-2 py-1 bg-primary-500/90 text-background-50 rounded-md whitespace-nowrap">{card.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 leading-relaxed line-clamp-2 group-hover:text-primary-600 transition-colors">{card.title}</h3>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="whitespace-nowrap">{card.time}</span>
                  <span className="flex items-center gap-1 whitespace-nowrap"><i className="ri-eye-line"></i> {(card.reads / 1000).toFixed(0)}k</span>
                  <span className="flex items-center gap-1 whitespace-nowrap"><i className="ri-chat-1-line"></i> {card.comments}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}